import * as Accordion from "@radix-ui/react-accordion";
import styled from "styled-components";

export const Header = styled(Accordion.Header)`
  display: block;
  width: 100%;
`;
